import { Box, Stack } from "@mui/material";
import CardDsfrContext from "components/CardDsfrContext";
import DSFRListContext from "components/DSFRListContext";
import HelpAndShare from "components/LayoutFront/HelpAndShare";
import Wrapper from "components/LayoutFront/Wrapper";
import TemplateBanner from "components/templatesComponents/TemplateBanner";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const MissionsDsfr = (props) => {
  const { page = {} } = props;
  const { contents, shortDescription, template, title } = page;
  const { missionsTitle, missions, dynamicPart } = contents;

  const cardDsfrContextArticlesValue = useMemo(
    () => ({ isHorizontal: true, showImage: true, showDescription: true }),
    [],
  );

  const dsfrListContextArticlesValue = useMemo(() => ({ xs: 12, sm: 12, lg: 12 }), []);

  const bo = useMemo(() => typeof title === "object", [title]);

  return (
    <>
      <TemplateBanner bo={bo}>
        <Stack>
          <h1>{title}</h1>
          {shortDescription && <p className="fr-text--xl">{shortDescription}</p>}
        </Stack>
      </TemplateBanner>
      <Wrapper sx={{ "& h2": { mt: 4 } }}>
        <Box sx={{ px: { xs: 2, lg: 0 }, "& button": { my: 2 } }}>
          {missionsTitle && <h2>{missionsTitle}</h2>}
          <DSFRListContext.Provider value={dsfrListContextArticlesValue}>
            <CardDsfrContext.Provider value={cardDsfrContextArticlesValue}>{missions}</CardDsfrContext.Provider>
          </DSFRListContext.Provider>
        </Box>
        {dynamicPart}
        <HelpAndShare alwaysDisplayShare template={template} />
      </Wrapper>
    </>
  );
};

MissionsDsfr.propTypes = {
  page: PropTypes.shape(),
};

export default MissionsDsfr;
